import classNames from 'classnames';
import { useRef } from 'react';
import useClickOutside from 'src/hooks/useClickOutside';
import styles from './styles.module.scss';

export interface IContextMenuProps {
  visible: boolean;
  position: {
    clientX: number;
    clientY: number;
  };
  children: React.ReactNode;
  onHide: () => void;
  className?: string;
}

const ContextMenu = ({ onHide, children, position, visible, className }: IContextMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);

  useClickOutside(ref?.current, onHide);

  return (
    <div
      ref={ref}
      className={classNames(styles.contextMenu, { [styles.visible]: visible }, className)}
      role='menu'
      style={{ left: position.clientX, top: position.clientY }}
    >
      {children}
    </div>
  );
};

export default ContextMenu;
